import { useState, useEffect } from 'react';
import { api } from '../api';

const MONTHS = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];

function fmtCurrency(val) {
  if (val === undefined || val === null) return '—';
  const n = Number(val);
  if (isNaN(n) || n === 0) return '₹0';
  if (n >= 10000000) return '₹' + (n / 10000000).toFixed(1) + 'Cr';
  if (n >= 100000)   return '₹' + (n / 100000).toFixed(1) + 'L';
  if (n >= 1000)     return '₹' + (n / 1000).toFixed(1) + 'K';
  return '₹' + n.toLocaleString('en-IN');
}

export default function Dashboard() {
  const [stats, setStats]   = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getStats()
      .then(setStats)
      .catch(() => setStats({}))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading-msg">Loading dashboard…</div>;

  const s = stats || {};

  const attendanceValue = s.attendanceTotalToday > 0
    ? `${s.attendancePresentToday}/${s.attendanceTotalToday}`
    : '—';
  const attendanceSub = s.attendanceTotalToday > 0
    ? `${s.attendanceTotalToday - s.attendancePresentToday} absent today`
    : 'No attendance marked today';

  const statCards = [
    { label: 'Total Students',     value: s.totalStudents    ?? '—', sub: 'Active students',          color: 'blue',   icon: 'fas fa-user-graduate' },
    { label: 'Teachers',           value: s.totalTeachers    ?? '—', sub: 'Active teachers',          color: 'green',  icon: 'fas fa-chalkboard-teacher' },
    { label: 'Fees Collected',     value: fmtCurrency(s.feesCollected),  sub: 'Total collected',       color: 'orange', icon: 'fas fa-rupee-sign' },
    { label: "Today's Attendance", value: attendanceValue,              sub: attendanceSub,             color: 'purple', icon: 'fas fa-calendar-check' },
    { label: 'Salary This Month',  value: fmtCurrency(s.salaryThisMonth), sub: 'Current month',       color: 'red',    icon: 'fas fa-wallet' },
    { label: 'Classes',            value: s.totalClasses     ?? '—', sub: 'Total class sections',     color: 'teal',   icon: 'fas fa-school' },
  ];

  const holidays = s.upcomingHolidays || [];

  return (
    <div>
      <div className="stats-grid">
        {statCards.map(c => (
          <div className="stat-card" key={c.label}>
            <div className={`stat-icon ${c.color}`}><i className={c.icon}></i></div>
            <div>
              <div className="stat-label">{c.label}</div>
              <div className="stat-value">{c.value}</div>
              <div className="stat-sub">{c.sub}</div>
            </div>
          </div>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 20, marginTop: 20 }}>

        {/* Recent Activity — empty state until real events are wired */}
        <div className="card">
          <div className="card-header">
            <div>
              <div className="card-title">Recent Activity</div>
              <div className="card-subtitle">Last 7 days</div>
            </div>
          </div>
          <div className="card-body">
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#a0aec0' }}>
              <i className="fas fa-history" style={{ fontSize: 36, marginBottom: 12, display: 'block' }}></i>
              <div style={{ fontSize: 14 }}>No recent activity yet</div>
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>

          {/* Fee Defaulters — clean empty state */}
          <div className="card">
            <div className="card-header"><div className="card-title">Fee Defaulters</div></div>
            <div className="card-body">
              <div style={{ textAlign: 'center', padding: '24px 0', color: '#a0aec0' }}>
                <i className="fas fa-check-circle" style={{ fontSize: 30, color: '#48bb78', marginBottom: 8, display: 'block' }}></i>
                <div style={{ fontSize: 13 }}>No defaulters</div>
              </div>
            </div>
          </div>

          {/* Upcoming Holidays — school sets their own, no hardcoded defaults */}
          <div className="card">
            <div className="card-header"><div className="card-title">Upcoming Holidays</div></div>
            <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {holidays.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '16px 0', color: '#a0aec0' }}>
                  <i className="fas fa-calendar-times" style={{ fontSize: 26, marginBottom: 8, display: 'block' }}></i>
                  <div style={{ fontSize: 13 }}>No holidays scheduled</div>
                  <div style={{ fontSize: 11, marginTop: 4 }}>Add holidays from the Holidays section</div>
                </div>
              ) : holidays.map((h, i) => {
                const d = new Date(h.holidayDate);
                return (
                  <div key={i} style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                    <div style={{ background: '#fff5f5', color: '#c53030', borderRadius: 8, padding: '4px 10px', textAlign: 'center', minWidth: 44, flexShrink: 0 }}>
                      <div style={{ fontSize: 16, fontWeight: 800 }}>{String(d.getDate()).padStart(2, '0')}</div>
                      <div style={{ fontSize: 9, fontWeight: 600 }}>{MONTHS[d.getMonth()]}</div>
                    </div>
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 600 }}>{h.name}</div>
                      <div style={{ fontSize: 11, color: '#a0aec0' }}>{h.holidayType || 'Holiday'}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
